import React from 'react'
import Lottie from 'lottie-react';
import MQRLoader from '../AnimationLottieFiles/MQRLoader.json'

const PageLoader = () => {
    return (
        <div className="flex justify-center items-center h-screen bg-white">
            <Lottie animationData={MQRLoader} loop={true} />
        </div>
    )
}

export default PageLoader